/* eslint-disable use-isnan */
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  colors,
  Divider,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  Zoom,
} from "@mui/material";
import { app } from "../../services";
import ReactECharts from "echarts-for-react"; // or var ReactECharts = require('echarts-for-react');
import * as echarts from "echarts";
import moment from "moment";
import "./itemDashboardFavorites.css";
import useMeasure from "react-use-measure";
import { useTheme } from "@mui/styles";
import Papa from "papaparse";
import Selector from "../ViewersLevels/Selector";
import IAReports from "../IAReports";
import BatteryIndicator from "../BatteryIndicator";
import {
  Download,
  NotificationsActiveOutlined,
  UpdateDisabledOutlined,
  UpdateOutlined,
} from "@mui/icons-material";
import ButtonDateRange from "../../common/ButtonDateRange";
import { useSelector } from "react-redux";
import { buildRegisterRows, processData } from "./repository.js";
import {
  buildExtremaMarkLine,
  buildExtremaMarkPoint,
  getGaugeLabelFontSize,
} from "./chartUtils.js";
import IconMask from "../IconMask.js";
import { socketApp } from "../../services";
const colorsArray = [
  "#80FFA5",
  "#00DDFF",
  "#37A2FF",
  "#FF0087",
  "#FFBF00",
  "#80FFA5",
  "#00DDFF",
  "#37A2FF",
  "#FF0087",
  "#FFBF00",
  "#80FFA5",
  "#00DDFF",
  "#37A2FF",
  "#FF0087",
  "#FFBF00",
  "#80FFA5",
  "#00DDFF",
  "#37A2FF",
  "#FF0087",
  "#FFBF00",
];
function ItemDashboard({
  selected,
  defaultMeasure,
  lite = false,
  alarms = [],
}) {
  const token = useSelector((state) => state.session.token);
  const [limitsRange, setLimitsRange] = useState([
    moment().add(-3, "months"),
    moment().add(1, "days"),
  ]);
  const [loadingData, setLoadignData] = useState({
    loading: false,
    error: null,
  });
  const [data, setData] = useState([]);
  const [lastData, setLastData] = useState({ data: null, process: false });
  const [bat, setBat] = useState(null);
  const [forwardActive, setForwardActive] = useState(true);
  const [range, setRange] = useState([moment().add(-1, "days"), moment()]);
  const [loading, setLoading] = useState(true);
  const [refChart, boundInner] = useMeasure();
  const theme = useTheme();
  const [typesMeasures, setTypesMeasures] = useState(
    defaultMeasure ? [defaultMeasure] : []
  );
  const [measureSelect, setMeasureSelect] = useState();
  const [measuresSelected, setMeasuresSelected] = useState([]);
  const [customConfig, setCustomConfig] = useState({ options: {}, series: [] });
  const [reportContext, setReportContext] = useState({ selected, eventConfigurations: [] });
  const events = socketApp.service("events");
  const isMd = useMediaQuery(theme.breakpoints.up("sm"), {
    defaultMatches: true,
  });
  useEffect(() => {
    let active = true;
    const loadReportContext = async () => {
      setReportContext({ selected, eventConfigurations: [] });
      if (!selected?.id) return;
      let deviceSection = null;
      try {
        deviceSection = await app.service("devices-sections").get(selected.id);
      } catch (error) {
        try {
          const response = await app.service("devices-sections").find({
            query: { $and: [{ id_dispositivo: selected.id }], $limit: 1 },
          });
          deviceSection = (response?.data || response || [])[0] || null;
        } catch (findError) {
          deviceSection = null;
        }
      }
      if (!active) return;

      let eventConfigurations = [];
      if (deviceSection?.id_seccion) {
        try {
          const [eventsResponse, typesResponse] = await Promise.all([
            app.service("schedules-configuration").find({ query: { $and: [{ id_activo: deviceSection.id_seccion }], $limit: 100 } }),
            app.service("types-schedules").find({ query: { $limit: 100 } }),
          ]);
          const types = typesResponse?.data || typesResponse || [];
          const typeById = new Map(types.map((item) => [item.id, item]));
          eventConfigurations = (eventsResponse?.data || eventsResponse || []).map((item) => ({
            ...item,
            tipo: item.tipo || typeById.get(item.id_tipo),
          }));
        } catch (error) {
          eventConfigurations = [];
        }
      }
      if (!active) return;
      const sourceDevice = deviceSection?.dispositivo || selected?.dispositivo || {};
      setReportContext({
        selected: {
          ...sourceDevice,
          ...selected,
          json_ubicacion: deviceSection?.json_ubicacion ?? selected?.json_ubicacion,
          vc_lat: deviceSection?.vc_lat ?? selected?.vc_lat,
          vc_lon: deviceSection?.vc_lon ?? selected?.vc_lon,
          tipo: selected?.tipo || sourceDevice?.tipo,
        },
        eventConfigurations,
      });
    };
    loadReportContext();
    return () => { active = false; };
  }, [selected?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  // console.log('range .---------->', range);
  const getDataRetry = async () => {
    let response = null;
    try {
      setLoadignData({ loading: true });
      const params = {
        // selected,
        // measuresSelected: measuresSelected || [],
        $limit: 30000,
        $skip: 0,
        $where: [{ id_dispositivoArea: selected?.id }],
        $or: {
          vc_field: [
            ...measuresSelected.map((meas) => meas.vc_fieldName),
            ...(!!typesMeasures.find((e) => e.vc_fieldName === "BAT")
              ? ["BAT"]
              : []),
          ],
        },
        // $between: [moment(!!limitsRange[0] && range[0] * 1 < limitsRange[0] * 1 ? limitsRange[0] : range[0]).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'), moment(!!limitsRange[1] && range[1] * 1 > limitsRange[1] * 1 ? limitsRange[1] : range[1]).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')], // Agrega el rango de fechas aquí
        // $between: [moment(!!limitsRange[0] && range[0] * 1 < limitsRange[0] * 1 ? limitsRange[0] : range[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(!!limitsRange[1] && range[1] * 1 > limitsRange[1] * 1 ? limitsRange[1] : range[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')], // Agrega el rango de fechas aquí
        $between: [
          moment(
            !!limitsRange[0] && range[0] * 1 < limitsRange[0] * 1
              ? limitsRange[0]
              : range[0]
          )
            .startOf("day")
            .toDate(), // ← Retorna un objeto Date con zona horaria local

          moment(
            !!limitsRange[1] && range[1] * 1 > limitsRange[1] * 1
              ? limitsRange[1]
              : range[1]
          )
            .endOf("day")
            .toDate(), // ← También aquí
        ], // Agrega el rango de fechas aquí
        $order: [["updatedAt", "DESC"]],
      };

      if (forwardActive) {
        params.$between = undefined;
        params.$limit = 50;
      }
      var baseURL = process.env.REACT_APP_API_URL || "http://localhost:3030";
      // console.log("query ---->", JSON.parse(JSON.stringify(params)));
      const url = `${baseURL}/events?dataString=${JSON.stringify(params)}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // Verificar si la respuesta es exitosa (código de estado 2xx)
      if (res?.ok) {
        // Obtener la data
        response = await res?.json();
        // Manejar la data
        // console.log("response", response);
      } else {
        // Manejar errores de la solicitud
        console.error(
          "Error al realizar la solicitud:",
          res?.status,
          res?.statusText
        );
      }
      setLoadignData({ loading: false });
    } catch (error) {
      setLoadignData({ loading: false, error: error });
      console.log("error", error);
    }
    return response;
  };
  const getEvents = async (animationLoad) => {
    if (animationLoad) {
      setLoading(true);
    }
    // console.log('measure selected', measuresSelected);
    if (measuresSelected.length) {
      let response = null;

      response = await getDataRetry();

      if (!response?.data) {
        setLoading(false);
        return;
      }
      setData(response.data || []);
    } else {
      setLoading(false);
      // setCustomConfig({ ...customConfig, series: [] });
    }
  };

  const getTypes = async () => {
    const types = await app
      .service("custom-devices-sections")
      .find({ query: selected });
    // console.log('types', types);
    setTypesMeasures(types?.rows || []);
    if (!measureSelect) {
      // console.log("types------>", types);
      setMeasuresSelected((types?.rows || []).filter((e) => e.bl_default));
    }
  };

  useEffect(() => {
    if (!!selected?.id && !!measuresSelected.length) {
      getEvents(true);
    }
  }, [selected?.id, measuresSelected, range, forwardActive]);

  useEffect(() => {
    // console.log("update data", data, lastData);
    if (data.length && !lastData.process) {
      const processDataAsync = () => {
        const newConfig = processData(customConfig, data, measuresSelected);
        setBat(newConfig.bat);
        setCustomConfig(newConfig);
      };
      processDataAsync();
      setLoading(false);
    } else if (!!lastData.process) {
      // console.log("no cumple last data", data, lastData);
      setData([...data, lastData.data]);
      setLastData({ data: null, process: false });
    }
  }, [data, lastData]);

  const buildChannelPayload = (value) => {
    if (Array.isArray(value)) return { channels: value };
    return { channel: value };
  };

  async function suscribe(channels = selected?.id) {
    const payload = buildChannelPayload(channels);
    const res = await socketApp.service("suscribe").create(payload);
    console.log("suscribe------------->", res);
  }
  async function unsuscribe(channels = selected?.id) {
    const payload = buildChannelPayload(channels);
    const res = await socketApp.service("suscribe").remove(null, { query: payload });
    console.log("unsuscribe------------->", res);
  }
  const handleObserverCreated = (item) => {
    console.log("created event", item, selected);
    console.log("event", { ...item.event, registros: item.registers || [] });
    if (selected?.id == item?.event?.id_dispositivoArea) {
      setLastData({
        data: { ...item.event, registros: item.registers || [] },
        process: true,
      });
    }
  };
  const handleObserverUpdated = (item) => {
    console.log("updated event", item, selected);
    if (selected?.id == item.id_dispositivoArea) {
      setLastData({
        data: { ...item.event, registros: item.registers || [] },
        process: true,
      });
    }
  };
  useEffect(() => {
    if (!selected?.id) return undefined;
    suscribe(selected.id);
    events.on("created", handleObserverCreated);
    events.on("updated", handleObserverUpdated);
    return () => {
      unsuscribe(selected.id);
      events.off("created", handleObserverCreated);
      events.off("updated", handleObserverUpdated);
    };
  }, [selected?.id]);

  useEffect(() => {
    if (!defaultMeasure && !!selected?.id) {
      setCustomConfig((prev) => ({ ...prev, series: [] }));
      getTypes();
    }
  }, [selected?.id]);
  // useEffect(() => {
  //   // console.log('entro lastDataDate', lastDataDate);
  //   getEvents(false);
  // }, [range])
  const colorsAlarms = customConfig?.series?.map((serie, index) => {
    const alarmDevice = alarms.filter(
      (e) =>
        e.id_tipoMedida === serie?.measure?.id &&
        (serie?.gauge?.value > e.nu_max || serie?.gauge?.value < e.nu_min)
    );
    switch (true) {
      case alarmDevice.length > 0: {
        return "red";
      }
      default: {
        return [
          (customConfig.series[0] || { color: "#00FFBB" }).gauge?.color,
          "#FFBB00",
          "#11FFAA",
          "#11FFFF",
        ][index];
      }
    }
  });
  const isConsumo = !!measuresSelected.find(
    (e) => e.id_medida === "e96ddeba-603f-462d-833c-d1fd4d46bed1"
  );
  // ✅ FIX: rain detect correcto
  const isRain = (customConfig.series || []).some((serie) => {
    const abbr = `${serie?.measure?.medida?.vc_abreviatura || ""}`.toLowerCase();
    const field = `${serie?.measure?.vc_fieldName || serie?.measure?.vc_tag || ""}`.toLowerCase();
    return abbr === "rain" || field === "rain";
  });
  const rainLatestValue = useMemo(() => {
    const lastObj = customConfig?.lastObj || null;
    if (`${lastObj?.vc_field || ""}`.toLowerCase() === "rain" && lastObj?.nu_value != null) {
      return Number(lastObj.nu_value);
    }

    const rainSeries = (customConfig.series || []).find((serie) => {
      const abbr = `${serie?.measure?.medida?.vc_abreviatura || ""}`.toLowerCase();
      const field = `${serie?.measure?.vc_fieldName || serie?.measure?.vc_tag || ""}`.toLowerCase();
      return abbr === "rain" || field === "rain";
    });

    if (!rainSeries) return null;
    if (rainSeries?.data?.length) {
      const latestPoint = [...rainSeries.data]
        .reverse()
        .find((point) => point?.[1] !== null && point?.[1] !== undefined);
      if (latestPoint) return Number(latestPoint[1]);
    }
    if (rainSeries?.gauge?.value != null) {
      return Number(rainSeries.gauge.value);
    }
    return null;
  }, [customConfig?.lastObj, customConfig?.series]);
  const rainMainIcon = rainLatestValue === 1
    ? "assets/icons/Estado_Lluvia.svg"
    : "assets/icons/Estado_Sol.svg";
  const parentWidth = boundInner?.width || 0;
  const safeWidth = parentWidth > 0 ? parentWidth : (isMd ? 640 : 320);
  const horizontalLayout = (isMd || isConsumo) && safeWidth > 520;
  const safeGaugeWidth = horizontalLayout ? Math.min(safeWidth * 0.38, 420) : safeWidth;
  const safeGaugeHeight = Math.max(Math.min(safeGaugeWidth, 380), 220);
  const registerRows = useMemo(
    () => buildRegisterRows(customConfig.series || [], 50),
    [customConfig.series]
  );
  const gaugeSeriesCount = customConfig.series?.length || 0;
  const denseGaugeLabels = gaugeSeriesCount >= 5;

  return [
    <Button
      key="btn-forward"
      size={"small"}
      onClick={() => setForwardActive(!forwardActive)}
    >
      {forwardActive ? <UpdateOutlined /> : <UpdateDisabledOutlined />}
    </Button>,

    <ButtonDateRange
      key="daterange"
      defaultValue={range}
      onChange={(e) => setRange(e)}
      limits={limitsRange}
      forwardActive={forwardActive}
    />,

    <Paper
      key={`selector-${selected?.id}`}
      style={{ marginBottom: 8, borderRadius: 10, width: "100%" }}
    >
      <Selector
        value={measureSelect}
        measuresSelected={measuresSelected}
        colors={colorsArray}
        options={typesMeasures}
        onSelect={(e) => setMeasuresSelected([e])}
        onSelectGroups={(e) => {
          if (
            (e.measures || []).filter((m) => measuresSelected.includes(m)).length ===
            (e.measures || []).length &&
            (e.measures || []).length > 0
          ) {
            setMeasuresSelected([]);
          } else {
            setMeasuresSelected(e.measures);
          }
        }}
      />
    </Paper>,

    <div
      ref={refChart}
      key={`panel-${selected?.id}`}
      className={"grid-container"}
      style={{
        width: "100%",
        maxWidth: "calc(100% - 1px)",
        flexDirection:
          horizontalLayout ? "row" : "column-reverse",
        display: "flex",
        minHeight: isMd ? 300 : 240,
        height: "auto",
        position: "relative",
        justifyContent: "center",
        backgroundColor: 'transparent'
      }}
    >
      {!isConsumo && (
        <div
          key={"chart"}
          className={isMd ? "left-component" : "center-component"}
          style={{
            paddingRight: horizontalLayout ? 8 : 0,
            position: "relative",
            display: "flex",
            flex: 1,
          }}
        >
          <Paper
            style={{
              display: "flex",
              borderRadius: 10,
              height: "100%",
              width: "100%",
              overflow: "hidden",
              position: "relative",
              border: "1px solid rgba(200,200,200,0.3)",
            }}
          >
            {!loading && !isConsumo && (
              <ReactECharts
                id={`${measuresSelected.map((e) => e.vc_name)}`}
                style={{ width: "100%", height: "100%", minHeight: isMd ? 280 : 220 }}
                option={{
                  animationDuration: 450,
                  animationDurationUpdate: 250,
                  animationEasing: "cubicOut",
                  animationEasingUpdate: "cubicOut",
                  color:
                    customConfig.series.length > 1
                      ? customConfig.series.map((e) => e.color)
                      : colorsArray,
                  backgroundColor: "transparent",
                  tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "cross", label: {} },
                    valueFormatter: (value) => Number(value).toFixed(2),
                  },
                  legend: { data: customConfig.series.map((e) => e.name) },
                  toolbox: { feature: { saveAsImage: {} } },
                  grid: { left: "9%", right: "9%", top: "18%", bottom: "8%", containLabel: false },
                  xAxis: [
                    {
                      type: "category",
                      boundaryGap: false,
                      data: customConfig.options?.xaxis?.categories || [],
                    },
                  ],
                  yAxis: [{ show: false, type: "value" }],
                  series: customConfig.series.map((serie, seriesIndex) => ({
                    name: serie.name,
                    type: "line",
                    smooth: true,
                    connectNulls: true,
                    lineStyle: {
                      width: customConfig.series?.length > 1 ? 2 : 0.1,
                      opacity: 1,
                      shadowColor: "black",
                      shadowOffsetX: 0,
                      shadowBlur: 10,
                    },
                    showSymbol: false,
                    areaStyle: {
                      show: customConfig.series?.length > 1 ? false : true,
                      opacity: customConfig.series?.length > 1 ? 0 : 0.8,
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "rgba(128, 255, 165, 0.5)" },
                        { offset: 1, color: "rgba(1, 191, 236, 0.2)" },
                      ]),
                    },
                    emphasis: { focus: "series" },
                    data: serie.data?.map((e) => e[1] ?? null) || [],
                    clip: true,
                    markPoint: buildExtremaMarkPoint(
                      serie,
                      seriesIndex,
                      customConfig.series.length
                    ),
                    markLine: buildExtremaMarkLine(serie),
                  })),
                }}
                notMerge={true}
                lazyUpdate={false}
                theme={"dark"}
              />

            )}
          </Paper>
        </div>
      )}

      <div
        id="container-gauge"
        key={"gauge"}
        className={horizontalLayout ? "right-component" : "center-component"}
        style={{
          display: "block",
          flex: isMd ? "0 0 38%" : 1,
          maxWidth: isMd ? 420 : "100%",
          minHeight: safeGaugeHeight,
        }}
      >
        <Paper
          style={{
            display: "flex",
            borderRadius: 10,
            height: "100%",
            width: "100%",
            overflow: "hidden",
            border: safeWidth > 400 ? "1px solid rgba(200,200,200,0.3)" : "none",
            position: "relative",
          }}
        >
          {/* ✅ Si es rain: SOLO GIF. Si no: gauge */}
          {!isConsumo && !isRain ? (
            <ReactECharts
              style={{ width: "100%", height: "100%", minHeight: safeGaugeHeight }}
              option={{
                animationDuration: 450,
                animationDurationUpdate: 250,
                animationEasing: "cubicOut",
                animationEasingUpdate: "cubicOut",
                color: colorsArray || colorsAlarms,
                backgroundColor: "transparent",
                series: [
                  {
                    type: "gauge",
                    min: customConfig.gauge?.min?.value * 0.9 || 0,
                    max: customConfig.gauge?.max?.value * 1.1 || 1,
                    startAngle: 90,
                    endAngle: -270,
                    pointer: { show: false },
                    progress: {
                      show: true,
                      overlap: false,
                      roundCap: true,
                      clip: false,
                      itemStyle: {
                        width: 10,
                        borderWidth: 1,
                        borderColor: "rgba(0,0,0,0.2)",
                      },
                    },
                    axisLine: {
                      lineStyle: {
                        width: 20,
                        color: [[1, "rgba(255,255,255,0.18)"]],
                      },
                    },
                    splitLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: { show: false },
                    data: (customConfig.series || [])
                      .filter(
                        (serie) =>
                          serie?.gauge?.value !== null &&
                          serie?.gauge?.value !== undefined &&
                          Number.isFinite(Number(serie.gauge.value))
                      )
                      .map((serie) => ({
                      value: Number(serie.gauge.value),
                      name: serie?.name || "",
                      title: { show: false },
                      detail: { show: false },
                    })),
                  },
                ],
              }}
              notMerge={false}
              lazyUpdate={false}
              theme={"dark"}
            />
          ) : (
            <Box
              style={{
                width: "100%",
                display: customConfig?.series?.length ? "flex" : "none",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                backgroundColor: 'transparent'
              }}
            >
              {
                isRain ?
                  <img
                    src={rainMainIcon}
                    style={{
                      width: '40%',
                      maxHeight: 220,
                      background: "transparent",
                      pointerEvents: "none",
                    }}
                    alt=""
                  />
                  :
                  [<IconMask
                    color={theme.palette.primary.main}
                    url={"assets/images/flujometro.png"}
                    size={safeWidth * 0.7}
                  />,
                  ]
              }
            </Box>
          )}

          <Box width={"100%"} position="absolute" bottom={"10px"} p={0}>
            <Typography
              key={"date"}
              color={"inherit"}
              style={{ width: "100%", fontSize: "0.7rem", textAlign: "center" }}
            >
              {"Fecha de registro: "}
              {!!customConfig.lastObj &&
                moment(customConfig.lastObj?.createdAt).format("DD-MM-YYYY HH:mm:ss")}
            </Typography>
          </Box>

          {/* ✅ Ocultar bloque numérico si es rain */}
          <Box
            width={"100%"}
            position="absolute"
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            display={isConsumo || isRain ? "none" : "flex"}
            left={0}
            top={0}
            height={"100%"}
            zIndex={2}
            pointerEvents="none"
            p={0}
          >
            <Box
              width={"100%"}
              position="relative"
              flexDirection={customConfig.series.length > 1 ? "row" : "row"}
              justifyContent={"center"}
              alignItems={"center"}
              display="flex"
              height="100%"
            >
              <Box
                position="relative"
                alignSelf={"center"}
                flexDirection={customConfig.series.length > 1 ? "column" : "row"}
                justifyContent={"center"}
                alignItems={"center"}
                display="flex"
                style={{
                  width: gaugeSeriesCount === 1 ? "68%" : denseGaugeLabels ? "62%" : "58%",
                  maxWidth: safeGaugeWidth * (gaugeSeriesCount === 1 ? 0.68 : denseGaugeLabels ? 0.62 : 0.58),
                  minHeight: 48,
                  maxHeight: denseGaugeLabels ? "70%" : "58%",
                  overflow: "visible",
                  boxSizing: "border-box",
                  padding: denseGaugeLabels ? 2 : 4,
                }}
              >
                {customConfig.series?.map((serie, index) => {
                  const gaugeValue = serie?.gauge?.value;
                  const hasGaugeValue =
                    gaugeValue !== null &&
                    gaugeValue !== undefined &&
                    Number.isFinite(Number(gaugeValue));
                  const gaugeLabel = hasGaugeValue
                    ? `${Number(gaugeValue).toFixed(2) * 1}${serie?.measure?.medida?.vc_abreviatura !== " "
                      ? " " + (serie?.measure?.medida?.vc_abreviatura || "")
                      : ""}`
                    : "-";
                  const labelFontSize = getGaugeLabelFontSize({
                    gaugeWidth: safeGaugeWidth,
                    label: gaugeLabel,
                    seriesCount: gaugeSeriesCount,
                  });

                  return (
                    <Box
                      key={serie.name + index}
                      color={"inherit"}
                      style={{
                        alignItems: "center",
                        display: "flex",
                        flex: "1 1 auto",
                        justifyContent: "center",
                        minHeight: 0,
                        minWidth: 0,
                        padding: denseGaugeLabels ? "1px 0" : 2,
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        component="span"
                        color={serie?.color}
                        fontWeight={700}
                        style={{
                          alignItems: "center",
                          border: "none",
                          borderBottom: "none",
                          borderRadius: 0,
                          boxSizing: "border-box",
                          display: "inline-flex",
                          fontSize: labelFontSize,
                          height: "auto",
                          justifyContent: "center",
                          lineHeight: 1.08,
                          maxWidth: "100%",
                          overflow: "hidden",
                          padding: denseGaugeLabels ? "1px 4px" : "2px 4px",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          width: "fit-content",
                        }}
                      >
                        {gaugeLabel}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>

          <Box
            key={"IAR"}
            position="absolute"
            top={1}
            right={1}
            p={0}
            sx={{ pointerEvents: "auto", zIndex: 6 }}
          >
            {!!measuresSelected.length && (
              <IAReports
                values={customConfig.series}
                selected={reportContext.selected}
                range={range}
                alarms={alarms}
                eventConfigurations={reportContext.eventConfigurations}
              />
            )}
          </Box>

          <Box key={"BAT"} position="absolute" bottom={1} right={1} p={0}>
            {!!typesMeasures.find((e) => e.vc_fieldName === "BAT") && (
              <BatteryIndicator size={60} value={bat || 0} />
            )}
          </Box>

          {colorsAlarms.includes("red") && (
            <NotificationsActiveOutlined className={"alert"} style={{ position: "absolute", top: 16, left: 16 }} />
          )}

          {(!!loadingData.error || !!loadingData.loading) && (
            <Box
              sx={{
                position: "absolute",
                top: 8,
                left: 8,
                zIndex: 3,
                display: "flex",
                alignItems: "center",
                gap: 1,
                backgroundColor: "rgba(0,0,0,0.35)",
                border: "1px solid rgba(255,255,255,0.15)",
                borderRadius: 2,
                px: 1,
                py: 0.6,
              }}
            >
              {loadingData.loading ? (
                <CircularProgress size={16} />
              ) : (
                <Button
                  size="small"
                  variant="text"
                  color="inherit"
                  onClick={() => getEvents(true)}
                  sx={{ minWidth: 0, p: 0.2 }}
                >
                  <UpdateDisabledOutlined fontSize="small" />
                </Button>
              )}
            </Box>
          )}
        </Paper>
      </div>
    </div>,

    !lite && (
      <Typography key={"registers"} p={2} paddingLeft={3} width={"100%"} fontWeight="700">
        {"Registros:"}
        <IconButton
          onClick={() => {
            const keys = {};
            (customConfig.valuesResponse || []).forEach((v) => {
              (v.registros || []).forEach((r) => {
                keys[r.vc_field] = r.vc_field;
              });
            });

            const datos = (customConfig.valuesResponse || [])
              .filter((e) => !!(e.registros || []).length)
              .map((e) => {
                let obj = {
                  nombre: selected.vc_nombre,
                  registro: moment(e.createdAt).format("DD-MM-YYYY HH:mm:ss"),
                };
                Object.keys(keys).forEach((k) => (obj[k] = ""));
                (e.registros || []).forEach((r) => {
                  const value = r.nu_value === null || r.nu_value === undefined || r.nu_value === ""
                    ? null
                    : Number(r.nu_value);
                  obj[r.vc_field] = Number.isFinite(value) ? value.toFixed(2) : "";
                });
                return obj;
              });

            const csv = Papa.unparse(datos);
            const blob = new Blob([csv], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${selected.vc_nombre} - (${moment().format("DD-MM-YYYY HH:mm:ss")}).csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }}
          size="small"
          style={{ float: "right" }}
        >
          <Download />
        </IconButton>
      </Typography>
    ),

    !lite && (
      <Box
        key={"registersitems"}
        marginBottom={2}
        style={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          maxWidth: "100vw",
        }}
      >
        <Paper style={{ borderRadius: 10, width: "100%", overflowX: "scroll", border: "none" }}>
          <TableContainer component={Box} style={{ maxWidth: "100%", width: "100%" }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell key={"fechaHeader"}>Fecha</TableCell>
                  {customConfig.series.map((serie, i) => (
                    <TableCell style={{ whiteSpace: "nowrap" }} key={i} align="right">
                      {`${serie.measure?.vc_tag || serie.measure?.vc_fieldName || ""}`}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {registerRows.map((row) => (
                    <TableRow key={row.key}>
                      <TableCell key={"date"} align="left">
                        {row.date || "-"}
                      </TableCell>
                      {customConfig.series?.map((serie, i) => {
                        const field = row.values[i] || null;
                        if (isRain) {
                          const rainNum = field?.[1] != null ? Number(field[1]) : null;
                          if (rainNum === null || Number.isNaN(rainNum)) {
                            return (
                              <TableCell key={i} align="right" width={50}>
                                N/A
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell key={i} align="right" width={50}>
                              <img
                                src={rainNum === 1 ? "assets/icons/Estado_Lluvia.svg" : "assets/icons/Estado_Sol.svg"}
                                loop
                                autoplay
                                style={{
                                  width: 20,
                                  background: "transparent",
                                  pointerEvents: "none",
                                }}
                              />
                            </TableCell>

                          )
                        }
                        return (
                          <TableCell key={i} align="right">
                            {field?.[1] != null
                              ? (Number(field[1]).toFixed(2) * 1).toLocaleString("es-MX")
                              : "-"}
                            {` ${serie.measure?.medida?.vc_abreviatura || ""}`}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    ),
  ];
}

export default ItemDashboard;
